<template>
  <div class="factories">
    <mainmenu selected="factories"></mainmenu>

    <div class="container">
      <h1>{{ $t("factories.page_title") }}</h1>
      
      <p>
        <el-button @click='add_item()'>{{ $t("add_item") }}</el-button>
      </p>

      <el-table :data="Results" style="width: 100%" v-loading="tableLoadingVisible">
        <el-table-column :label="$t('factories.country')">
          <template slot-scope="scope">
            <span>{{scope.row.Country}}</span> 
            <div v-if="scope.row.NotifyForInvoiceOnApprove =='1'">
              <el-tag  size="mini">{{$t('factories.notify_for_invoice_approval')}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ShortCode" :label="$t('factories.code')" ></el-table-column>

        <el-table-column fixed="right" :label="$t('operations')" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.Id != '-1'">
              <el-button @click="edit_item(scope.row)"   type="text" size="small">{{ $t("edit") }}</el-button>
              <el-button @click="delete_item(scope.row)" type="text" size="small">{{ $t("delete") }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>
    </div>
    <factory-dialog ref="item_dialog" @save='refresh_info' />
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";
import FactoryDialog from "./../views/dialogs/FactoryDialog";

export default {
  name: "factories",
  components: {
    "mainmenu": MainMenu,
    "factory-dialog": FactoryDialog
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: {},
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] }
    }
  },
  methods: {
     refresh_info: function() {
       this.tableLoadingVisible = true;
       this.$http
          .post('factories/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          });
    },
    add_item: function(){
      this.$refs.item_dialog.show_me();
    },
    edit_item: function(item){
      this.$refs.item_dialog.show_me(item);
    },
    delete_item: function(item){
       this.$confirm( this.$t("confirm_delete"), this.$t("warning_title"), { 
         confirmButtonText: this.$t("confirm"), 
         cancelButtonText: this.$t("cancel"), 
         type: 'warning'
        }).then(() => {
          this.tableLoadingVisible = true;
          this.$http
              .post('factories/delete_item',  { object: item } )
              .then(function (response) {
                this.tableLoadingVisible = false;
                if( settings.verify_response(response, this.$rights)) {
                  this.refresh_info();
                } else {
                  this.$router.push("/");
                }
              });
        }).catch(()=>{ });
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>

</style>